import { RouteEnum } from "../../enums/RouteEnum";
import { useNavigate } from "react-router-dom";
import { JSX } from "react";
import { useStringTranslation } from "../../hooks/useStringTranslation";

export const Searchbar = (): JSX.Element => {
    const navigate = useNavigate();
    const { t, isLoading: isTranslationsLoading } = useStringTranslation();

    return (
        <div className="c-searchbar">
            <form className="c-searchbar__form">
                <input
                    type="search"
                    onClick={() => {
                        navigate(RouteEnum.SEARCH);
                    }}
                    placeholder={
                        isTranslationsLoading
                            ? "Loading..."
                            : t("search-for-machines-accessories-or-parts")
                    }
                />
                <div>
                    <img src="/images/search.svg" alt="search" />
                </div>
            </form>
        </div>
    );
};
